<template>
	<section v-if="show">
		<slot name="header"></slot>
		<section class="pins">
			<pins-item-patient v-for="patient in getPins" :key="patient.id" :patient="patient" />
		</section>
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
import PinsItemPatient from '@/modules/pins/PinsItemPatient'
export default {
	name: 'pins',
	components: {
		PinsItemPatient
	},
	computed: {
		show() {
			return this.getPins.length > 0
		},
		...mapGetters({
			getPins: 'GET_PIN_PATIENT_DASHBOARD'
		})
	}
}
</script>

<style scoped>
.pins {
	padding: 10px 0;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
	grid-column-gap: 15px;
	grid-row-gap: 15px;
}
</style>


// WEBPACK FOOTER //
// src/modules/pins/Pins.vue